import { Component } from '@angular/core';
import { CardModule } from 'axis-components';

@Component({
  selector: 'app-modal-uimui-disclosure-pdf',
  templateUrl: './modal-uimui-disclosure-pdf.component.html',
  styleUrl: './modal-uimui-disclosure-pdf.component.scss',
  standalone: true,
  imports: [CardModule],
})
export class ModalUimuiDisclosurePdfComponent {}
